import { render, staticRenderFns } from "./AttachmentDownloader.vue?vue&type=template&id=2f2d6942"
import script from "./AttachmentDownloader.vue?vue&type=script&lang=js"
export * from "./AttachmentDownloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports